module.exports = __webpack_public_path__ + "static/media/Seam_6722.14ae7764.jpg";